<template>
  <section class="event-help">
    <div class="help-cards">
      <!-- <div class="help-card">
          <h3>
            <img src="@/assets/icon/user-voice.svg" alt="" />
            参加者からの声
          </h3>
          <div class="help-card-content">
            <p>
              これまで参加頂いた医学部生からいただいた貴重なご意見を、是非参照ください。（仮）
            </p>
            <Button label="詳細はこちら" primary />
          </div>
        </div> -->
      <div />
      <div class="help-card">
        <h3>
          <img src="@/assets/icon/question-circle.svg" alt="" />
          よくある質問
        </h3>
        <div class="help-card-content">
          <p>
            イベントのご利用について、様々な疑問にお答えしています。
          </p>
          <Button
            label="詳細はこちら"
            primary
            :handleClick="() => $router.push('/faq')"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'EventDetailHelp',

  components: {
    Button
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.event-help {
  margin-top: 50px;
  .help-cards {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    gap: 40px;
    .help-card {
      border: 1px solid var.$color-border-gray;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      h3 {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var.$color-sub-bg-g;
        height: 50px;
        img {
          margin-right: 6px;
        }
      }
      .help-card-content {
        height: calc(100% - 50px);
        padding: 10px 20px 20px;
        display: grid;
        grid-template-rows: 1fr 60px;
      }
      button {
        margin-top: 10px;
      }
    }
  }
}
</style>
